/* eslint no-console: 0 */

<template>
  <div id="order-form">
    <form
      id="new_order"
      accept-charset="UTF-8"
      class="checkout-form-shell"
      @submit="submitOrder"
    >
      <div class="checkout-layout">
        <div class="checkout-layout__main">
          <div v-if="withErrors()" id="errors" class="checkout-errors checkout-card">
            <div class="checkout-errors__header">
              <p class="checkout-card__eyebrow">Проверьте форму</p>
              <h2 class="checkout-card__title">Есть ошибки в оформлении заказа</h2>
            </div>
            <ul class="checkout-errors__body">
              <li v-for="error in order.errors" :key="error">
                {{ error }}
              </li>
            </ul>
          </div>

          <section class="checkout-card checkout-section">
            <div class="checkout-section__head">
              <span class="checkout-section__number">1</span>
              <div>
                <p class="checkout-card__eyebrow">Доставка</p>
                <h2 class="checkout-card__title">Адрес и способ получения</h2>
              </div>
            </div>

            <div class="checkout-fields__row">
              <div class="checkout-fields__full uk-field">
                <label for="order_city" class="checkout-field__label uk-field__label">Город</label>
                <select
                  id="order_city"
                  v-model="order.city"
                  name="order_city"
                  class="checkout-field__input uk-select"
                  @change="cityChanged"
                >
                  <option
                    v-for="city in courierCities"
                    :key="city"
                    :value="city"
                  >
                    {{ city }}
                  </option>
                </select>
              </div>
            </div>

            <div class="checkout-fields__row">
              <div class="checkout-fields__full uk-field">
                <div class="checkout-field__label-row uk-field__label-row">
                  <span class="checkout-field__label uk-field__label">Способ доставки</span>
                  <a class="checkout-field__link" href="/delivery">Условия доставки</a>
                </div>

                <div class="checkout-delivery-options">
                  <label
                    v-for="dk in deliveryOptionsFiltered()"
                    :key="dk.id"
                    class="checkout-delivery-option uk-choice"
                    :class="{ 'is-selected': order.deliveryKind === dk.id }"
                  >
                    <input
                      :id="`delivery-kind-${dk.id}`"
                      v-model="order.deliveryKind"
                      type="radio"
                      name="delivery_kind"
                      :value="dk.id"
                      @change="deliveryKindChanged"
                    >
                    <span class="checkout-delivery-option__body">
                      <span class="checkout-delivery-option__title uk-choice__title">{{ dk.text }}</span>
                      <span class="checkout-delivery-option__meta uk-choice__sub">{{ deliveryDescription(dk.id) }}</span>
                    </span>
                    <span
                      class="checkout-delivery-option__price"
                      :class="{ 'checkout-delivery-option__price--free': dk.id === 'pickup' }"
                    >
                      {{ deliveryPriceLabel(dk.id) }}
                    </span>
                  </label>
                </div>

                <p class="checkout-preorder-note uk-field__hint">
                  {{ deliveryPolicyNote() }}
                </p>
              </div>
            </div>
          </section>

          <section class="checkout-card checkout-section">
            <div class="checkout-section__head">
              <span class="checkout-section__number">2</span>
              <div>
                <p class="checkout-card__eyebrow">Контакты</p>
                <h2 class="checkout-card__title">Данные получателя</h2>
              </div>
            </div>

            <div class="checkout-fields__row checkout-fields__split">
              <div class="checkout-fields__half uk-field">
                <label for="order_name" class="checkout-field__label uk-field__label uk-field__label--required">
                  Ваше имя
                </label>
                <input
                  id="order_name"
                  v-model="name"
                  placeholder="Анна"
                  type="text"
                  class="checkout-field__input uk-input"
                  required
                >
              </div>

              <div class="checkout-fields__half uk-field">
                <label for="order_phone" class="checkout-field__label uk-field__label uk-field__label--required">
                  Номер телефона
                </label>
                <input
                  id="order_phone"
                  v-model="phone"
                  placeholder="+7 (___) ___-____"
                  type="tel"
                  class="checkout-field__input uk-input"
                  required
                >
              </div>
            </div>

            <div class="checkout-fields__row">
              <div class="checkout-fields__full uk-field">
                <label
                  for="order_address"
                  class="checkout-field__label uk-field__label"
                  :class="{ 'uk-field__label--required': addressRequired() }"
                >
                  Адрес
                </label>
                <input
                  id="order_address"
                  v-model="address"
                  placeholder="Улица, дом, квартира"
                  type="text"
                  class="checkout-field__input uk-input"
                  :required="addressRequired()"
                >
              </div>
            </div>

            <div class="checkout-fields__row">
              <div class="checkout-fields__full uk-field">
                <label for="order_email" class="checkout-field__label uk-field__label">Email</label>
                <input
                  id="order_email"
                  v-model="email"
                  type="email"
                  placeholder="anna@example.com"
                  class="checkout-field__input uk-input"
                >
              </div>
            </div>

            <div class="checkout-fields__row">
              <div class="checkout-fields__full uk-field">
                <div class="checkout-field__label-row uk-field__label-row">
                  <label for="order_comment" class="checkout-field__label uk-field__label">Комментарий к заказу</label>
                </div>
                <textarea
                  id="order_comment"
                  v-model="comment"
                  placeholder="Например, желаемое время доставки или комментарий к примерке."
                  class="checkout-field__input checkout-field__textarea uk-textarea"
                ></textarea>
              </div>
            </div>
          </section>
        </div>

        <div class="checkout-layout__aside">
          <aside class="checkout-card checkout-summary-card">
            <div class="checkout-summary-card__head">
              <p class="checkout-card__eyebrow">Ваш заказ</p>
              <h2 class="checkout-card__title">Состав и итог</h2>
            </div>

            <div class="checkout-summary-items">
              <article v-for="li in cart.lineItems" :key="li.id" class="checkout-summary-item">
                <div class="checkout-summary-item__media">
                  <img
                    v-if="li.product.imageUrl"
                    :src="li.product.imageUrl"
                    :srcset="li.product.imageSrcset"
                    sizes="100px"
                    :width="li.product.imageWidth"
                    :height="li.product.imageHeight"
                    :alt="li.product.name"
                  >
                  <div v-else class="checkout-summary-item__placeholder">Товар</div>
                </div>
                <div class="checkout-summary-item__body">
                  <h3 class="checkout-summary-item__title">{{ li.product.name }}</h3>
                  <p v-if="itemMeta(li)" class="checkout-summary-item__meta">{{ itemMeta(li) }}</p>
                  <p v-if="!inStock(li)" class="checkout-summary-item__status">Предзаказ</p>
                </div>
                <div class="checkout-summary-item__price">{{ formatPrice(li.product.price) }}</div>
              </article>
            </div>

            <div class="checkout-summary-totals">
              <div class="checkout-summary-row">
                <span>Товары ({{ cart.lineItems.length }} шт.)</span>
                <span>{{ formatPrice(cart.price.lineItemsPrice) }}</span>
              </div>
              <div class="checkout-summary-row">
                <span>Доставка</span>
                <span>{{ deliveryPrice() }}</span>
              </div>
              <div v-if="promocodeApplied()" class="checkout-summary-row checkout-summary-row--discount">
                <span>Промокод</span>
                <span>-{{ formatPrice(cart.price.discount) }}</span>
              </div>
              <div class="checkout-summary-row checkout-summary-row--total">
                <span>Итого</span>
                <span>{{ formatPrice(cart.price.totalPrice) }}</span>
              </div>
            </div>

            <div class="checkout-payment-panel">
              <p class="checkout-field__label uk-field__label">Способ оплаты</p>
              <div class="checkout-payment-option uk-choice is-selected">
                <div class="checkout-payment-option__body">
                  <strong class="checkout-payment-option__title uk-choice__title">{{ paymentTitle() }}</strong>
                  <p class="checkout-payment-option__copy uk-choice__sub">{{ paymentDescription() }}</p>
                </div>
              </div>

              <p v-if="withPreorder()" class="checkout-preorder-note uk-field__hint">
                В заказе есть позиции с предзаказом. Менеджер свяжется с вами и уточнит ближайшую дату доставки.
              </p>

              <button
                type="submit"
                name="commit"
                class="uk-button uk-button-primary uk-button-lg checkout-submit"
                value="Сделать заказ"
                :disabled="loadingState"
              >
                Сделать заказ
                <div v-if="loadingState" class="btn-spinner">
                  <span class="uk-shell-sr-only">Загрузка</span>
                </div>
              </button>

              <p class="checkout-consent">
                Нажимая «Сделать заказ», вы принимаете условия
                <a href="/about/oferta">Публичной оферты</a>.
              </p>
            </div>
          </aside>

          <aside class="checkout-card checkout-coupon-card">
            <div class="checkout-coupon__message">
              <p v-if="!promocodeEntered && !promocodeApplied()">
                У вас есть купон?
                <a
                  href="#coupon_info"
                  class="checkout-coupon__toggle"
                  @click.prevent="togglePromocodeFieldVisible"
                >Нажмите для добавления</a>
              </p>
              <p v-else-if="promocodeApplied()">
                Промокод «{{ order.promocode }}» применен.
              </p>
              <p v-else>
                Проверьте код купона и попробуйте снова.
              </p>
            </div>

            <div id="coupon_info" :class="{ 'hide-in-default': !promocodeFieldVisible && !promocodeEntered && !promocodeApplied() }">
              <form v-if="!promocodeApplied()" class="form" @submit="submitPromocode">
                <div class="checkout-coupon__actions">
                  <input
                    id="promocode-input"
                    v-model="order.promocode"
                    placeholder="Введите промокод"
                    type="text"
                    class="checkout-field__input uk-input"
                    :class="{ error: promocodeEntered && !promocodeApplied() }"
                  >
                  <button type="submit" class="uk-button uk-button-secondary">Применить</button>
                </div>
                <p v-if="promocodeEntered && !promocodeApplied()" class="checkout-coupon__error uk-field__error">
                  Промокод не найден.
                </p>
              </form>
            </div>
          </aside>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  emits: ['update-price', 'submit-order'],
  props: {
    "cart": {
      type: Object,
      default () {
        return { error: "", lineItems: [], price: {} };
      }
    },
    "order": {
      type: Object,
      default () {
        return { errors: [], deliveryKind: "pickup", promocodeId: null, city: "Москва" };
      }
    },
    "deliveryOptions": {
      type: Array,
      default () {
        return ["Mосква"];
      }
    },
    "courierCities": {
      type: Array,
      default () {
        return [];
      }
    },
    "loadingState": Boolean,
  },
  data: function() {
    return {
      name: "",
      email: "",
      phone: "",
      address: "",
      comment: "",
      promocode: "",
      promocodeEntered: false,
      promocodeFieldVisible: false
    };
  },
  watch: {
    order: { handler: function() {
      if (this.order.errors.length == 0) { return; }
      document.getElementById("order-form").scrollIntoView();
    }, deep: true }
  },
  mounted() {
    this.$emit("update-price");
  },
  methods: {
    submitOrder: function(e) {
      const orderParams = {
        name: this.name,
        city: this.order.city,
        email: this.email,
        phone: this.phone,
        address: this.address,
        delivery_kind: this.order.deliveryKind,
        comment: this.comment,
        promocode: this.order.promocode,
      };

      this.$emit("submit-order", orderParams);
      e.preventDefault();
    },

    submitPromocode: function(e) {
      e.preventDefault();
      this.$emit("update-price");
      this.promocodeEntered = true;
    },

    deliveryKindChanged: function(e) {
      e.preventDefault();
      this.$emit("update-price");
    },

    cityChanged: function(e) {
      e.preventDefault();
      this.order.deliveryKind = this.deliveryOptionsFiltered()[0].id;
      this.$emit("update-price");
    },

    withErrors: function() {
      return this.order.errors && this.order.errors.length > 0;
    },

    withPreorder: function() {
      return this.cart.lineItems.some(function(e) {
        return e.product.status == "soon_in_stock";
      });
    },

    addressRequired: function() {
      return this.order.deliveryKind !== 'pickup';
    },

    deliveryOptionsFiltered: function() {
      return this.deliveryOptions.filter((opt) => {
        if (!['courier', 'express_courier', 'pickup'].includes(opt.id)) { return true; }
        return this.courierDeliveryPossible();
      });
    },

    deliveryDescription: function(deliveryKind) {
      const descriptions = {
        courier: 'Курьерская доставка по Москве в пределах МКАД с примеркой перед оплатой.',
        express_courier: 'Срочная курьерская доставка по Москве в пределах МКАД, если адрес подходит для экспресса.',
        pickup: 'Самовывоз из шоурума в Москве по предварительному согласованию.',
        sdek: 'Отправка через СДЭК после полной предоплаты заказа.',
        mail: 'Отправка Почтой России после полной предоплаты заказа.',
      };

      return descriptions[deliveryKind] || 'Стоимость и сроки уточним после подтверждения заказа.';
    },

    deliveryPriceLabel: function(deliveryKind) {
      if (deliveryKind === 'pickup') {
        return 'Бесплатно';
      }

      if (deliveryKind === 'courier' && deliveryKind !== this.order.deliveryKind) {
        return '450₽';
      }

      if (deliveryKind === 'express_courier' && deliveryKind !== this.order.deliveryKind) {
        return '850₽';
      }

      if (deliveryKind === this.order.deliveryKind) {
        return this.deliveryPrice();
      }

      return 'По тарифу';
    },

    courierDeliveryPossible: function() {
      return this.courierCities.includes(this.order.city);
    },

    requiresPrepayment: function() {
      return ['sdek', 'mail'].includes(this.order.deliveryKind);
    },

    paymentTitle: function() {
      if (this.requiresPrepayment()) {
        return 'Полная предоплата перед отправкой';
      }

      if (this.order.deliveryKind === 'pickup') {
        return 'Оплата при самовывозе';
      }

      return 'Оплата после примерки или при получении';
    },

    paymentDescription: function() {
      if (this.requiresPrepayment()) {
        return 'Для СДЭК и Почты России отправляем заказ только после полной оплаты. Ссылку на оплату пришлет менеджер после подтверждения.';
      }

      if (this.order.deliveryKind === 'pickup') {
        return 'Вы сможете оплатить заказ в шоуруме после подтверждения времени самовывоза.';
      }

      return 'Для курьера вы оплачиваете только те товары, которые оставите после примерки.';
    },

    deliveryPolicyNote: function() {
      if (this.requiresPrepayment()) {
        return 'За пределы МКАД отправляем СДЭК и Почтой России только после полной предоплаты. Стоимость и срок подтверждаем при согласовании заказа.';
      }

      return 'Курьерская доставка временно доступна только по Москве в пределах МКАД. Бесплатная доставка действует, если после примерки вы оставляете товары на сумму от 15 000 ₽. До выкупа в корзине показываем базовый тариф.';
    },

    deliveryPrice: function() {
      if (typeof(this.cart.price.deliveryPrice) == 'number') {
        return `${this.cart.price.deliveryPrice}₽`;
      }
      return this.cart.price.deliveryPrice;
    },

    formatPrice: function(value) {
      if (typeof(value) == 'number') {
        return `${value}₽`;
      }

      if (value === null || value === undefined || value === '') {
        return '0₽';
      }

      return value.toString().includes('₽') ? value : `${value}₽`;
    },

    itemMeta: function(lineItem) {
      const parts = [];
      const optionValue = lineItem.productVariant?.option?.value;
      const colorName = lineItem.productVariant?.color?.name;

      if (optionValue) {
        parts.push(`Размер: ${optionValue}`);
      }

      if (colorName) {
        parts.push(colorName);
      }

      return parts.join(' · ');
    },

    inStock: function(lineItem) { return (lineItem.product.status == "in_stock"); },
    promocodeApplied: function() { return this.cart.price.discount > 0; },
    togglePromocodeFieldVisible: function() { this.promocodeFieldVisible = !this.promocodeFieldVisible; }
  },
};
</script>
